import React from "react";
import "./about.css";

export default function About() {
  return (
    <div className="page about-page">
      <section className="panel about-panel">
        <h1>About</h1>
        <h2 className="about-muted">Who are we?</h2>
        <p>
          A Quiet Boom is…
        </p>
      </section>
    </div>
  );
}